import { StyleSheet } from 'react-native-unistyles'

export default StyleSheet.create((theme) => {
  return {
    textInputContainer: {
      columnGap: theme.tokens.spacing[4],
      flexDirection: 'row',
      flexWrap: 'wrap',
      rowGap: theme.tokens.spacing[3],
    },
  }
})
